import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getMakeover } from "./getMakeOverDetail";

export const updateDocument = createAsyncThunk(
  "ListingMakeover/updateDocument",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/transactions/makeover/document/${data.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      thunkAPI.dispatch(getMakeover({ id: resp.data?.makeover_id }));
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
